<ng-container *ngFor="let escalaGlobal of escalaGlobales">
    <escala-global-alias-instancia
        [evaluacionInstancia]="evaluacionInstancia"
        [escalaGlobal]="escalaGlobal"
        [evaluacionInstanciaEscalaGlobalAlias]="evaluacionInstanciaEscalaGlobalAliasByEscalaGlobalId[escalaGlobal.id]"
    ></escala-global-alias-instancia>
</ng-container>
